export const equipmentQueryKeys = {
  all: ['equipment'] as const,
  list: () => ['equipment', 'list'] as const,
  inactivityPeriods: (id: string) => ['equipment', 'inactivity-periods', id] as const,
  foodPresets: () => ['equipment', 'food-presets'] as const,
};

export const fryerQueryKeys = {
  all: ['fryer'] as const,
  list: () => ['fryer', 'list'] as const,
};

export const pestControlQueryKeys = {
  all: ['pest-control'] as const,
  list: () => ['pest-control', 'list'] as const,
  inactivityPeriods: (id: string) => ['pest-control', 'inactivity-periods', id] as const,
};

export const metalDetectorQueryKeys = {
  all: ['metal-detector'] as const,
  list: () => ['metal-detector', 'list'] as const,
};
